// 환경별 API 설정
const config = {
  development: {
    API_BASE_URL: 'https://skysunny-api-dev.mayoube.co.kr',
    BASE_URL: 'https://app-dev.skysunny.mayoube.co.kr', // 개발 환경 프론트엔드 URL
    ENV: 'development',
    // TOSS_CLIENT_KEY: 'test_gck_QbgMGZzorz545NqoE49lVl5E1em4' // 테스트용 키
    TOSS_CLIENT_KEY: 'test_gck_QbgMGZzorz545NqoE49lVl5E1em4' // 테스트용 키
  },
  staging: {
    API_BASE_URL: 'https://skysunny-api.mayoube.co.kr',
    BASE_URL: 'https://app.skysunny.mayoube.co.kr', // 스테이징 환경 프론트엔드 URL
    ENV: 'staging',
    TOSS_CLIENT_KEY: 'live_gck_BX7zk2yd8yOdX9GKAd2pVx9POLqK' // 스테이징 환경도 라이브 키 사용
  },
  production: {
    API_BASE_URL: 'https://api.skasca.co.kr',
    BASE_URL: 'https://app.skasca.co.kr', // 프로덕션 환경 프론트엔드 URL
    ENV: 'production',
    TOSS_CLIENT_KEY: 'live_gck_BX7zk2yd8yOdX9GKAd2pVx9POLqK' // 결제 위젯용 라이브 키
  }
};

// 현재 환경 결정 로직
const getCurrentEnvironment = () => {
  // 1. 환경변수에서 REACT_APP_ENV를 먼저 확인
  if (process.env.REACT_APP_ENV) {
    return process.env.REACT_APP_ENV;
  }

  // 2. URL 기반으로 환경 판단 (배포된 환경에서) - 가장 우선
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    
    // 프로덕션 환경 체크 (가장 먼저)
    if (hostname.includes('skasca.co.kr')) {
      // skasca.co.kr 도메인은 production 환경
      return 'production';
    }
    
    // 개발 환경 체크
    if (hostname.includes('dev') || hostname.includes('localhost') || hostname.includes('127.0.0.1')) {
      return 'development';
    }
    
    // 스테이징 환경 체크
    if (hostname.includes('staging') || hostname.includes('stg') || hostname.includes('skysunny.mayoube.co.kr')) {
      // skysunny.mayoube.co.kr 도메인은 staging 환경
      return 'staging';
    }
    
    // dev/staging/production이 아닌 실제 도메인이면 production
    if (!hostname.includes('localhost') && !hostname.includes('127.0.0.1')) {
      return 'production';
    }
  }

  // 3. NODE_ENV를 기반으로 환경 결정
  if (process.env.NODE_ENV === 'development') {
    return 'development';
  } else if (process.env.NODE_ENV === 'production') {
    // production 빌드에서는 production 환경 사용 (라이브 키)
    return 'production';
  }

  // 기본값은 development
  return 'development';
};

// 현재 환경의 설정 가져오기
const currentEnv = getCurrentEnvironment();
const currentConfig = {
  ...config[currentEnv] || config.development,
  // 환경변수에서 직접 API URL을 설정할 수 있도록 허용
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL || (config[currentEnv] || config.development).API_BASE_URL,
  // 환경변수에서 직접 BASE URL을 설정할 수 있도록 허용
  BASE_URL: process.env.REACT_APP_BASE_URL || (config[currentEnv] || config.development).BASE_URL,
  // 환경변수에서 직접 Toss Client Key를 설정할 수 있도록 허용
  TOSS_CLIENT_KEY: process.env.REACT_APP_TOSS_CLIENT_KEY || (config[currentEnv] || config.development).TOSS_CLIENT_KEY
};

console.log(`🌍 Current Environment: ${currentEnv}`);
console.log(`🔗 API Base URL: ${currentConfig.API_BASE_URL}`);
console.log(`🌐 Frontend Base URL: ${currentConfig.BASE_URL}`);
console.log(`💳 Toss Client Key: ${currentConfig.TOSS_CLIENT_KEY ? currentConfig.TOSS_CLIENT_KEY.slice(0, 8) + '...' : 'Not Set'}`);

export default currentConfig;

// 환경별 설정 전체를 export (필요시 사용)
export { config };
